var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuLink',{attrs:{"menus":['薬局一覧', 'ユーザ一覧', '薬局会社一覧', '近隣グループ一覧', '卸会社一覧', '医療用医薬品一覧']}})}
var staticRenderFns = []

export { render, staticRenderFns }